import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ContactAutocompleteService, ContactAutocompleteResult, ContactDetails } from 'src/app/services/contacts/contact-autocomplete.service';
import { IAddressOption } from 'src/app/freightmancerlvl99/freightmancerlvl99.models';

@Component({
  selector: 'app-pool-store-add-modal',
  templateUrl: './pool-store-add-modal.component.html',
  styleUrls: ['./pool-store-add-modal.component.scss']
})
export class PoolStoreAddModalComponent {
  storeForm!: FormGroup;
  storeAddressOptions: IAddressOption[] = [];

  constructor(
    private fb: FormBuilder, 
    private dialogRef: MatDialogRef<PoolStoreAddModalComponent>, 
    private contactSvc: ContactAutocompleteService,
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: { poolPointClientUuid: string, poolPointClientName: string, poolPointUuid: string}
  ){
    console.log('Modal got data: ', data);
  }

  ngOnInit(){
    this.storeForm = this.fb.group({
      pool_point_store_number: ['', Validators.required],
      pool_point_store_contact_uuid: ['', Validators.required],
      pool_point_store_contact_text: [''],
      pool_point_store_address_uuid: ['', Validators.required]
    });
  }

  get poolPointStoreContactControl(){
    return this.storeForm.get('pool_point_store_contact_text') as FormControl;
  }

  onStoreSelected(selected: ContactAutocompleteResult){
    this.storeForm.patchValue({
      pool_point_store_contact_uuid: selected.value,
      pool_point_store_contact_name: selected.label
    });

    this.contactSvc.getDetails(selected.value).subscribe((data: ContactDetails) => {
      // populate address options list
      console.log(data.addresses)
      this.storeAddressOptions = (data.addresses || []).map(addr => ({
        value: addr.contact_address_uuid,
        label: [addr.address, addr.address_extended, addr.locality, addr.region].filter(Boolean).join(', ')
      }));

      if (this.storeAddressOptions.length > 0){
        this.storeForm.get('pool_point_store_address_uuid')?.setValue(this.storeAddressOptions[0].value);
      }
    })
  }

  close(){
    this.dialogRef.close();
  }

  submit(){
    const url = '/api/pool_points/pool_point_stores.php';
    const postBody = {
      pool_point_uuid: this.data.poolPointUuid,
      pool_point_store_number: this.storeForm.get('pool_point_store_number')?.value,
      pool_point_store_contact_uuid: this.storeForm.get('pool_point_store_contact_uuid')?.value,
      pool_point_store_address_uuid: this.storeForm.get('pool_point_store_address_uuid')?.value,
      pool_point_client: this.data.poolPointClientName,
      pool_point_client_uuid: this.data.poolPointClientUuid
    }

    this.http.post<any>(url, postBody).subscribe(
      response => {
        if (response.code && response.code === '200'){
          this.toastr.success('Store added.');
        }
        else{
          this.toastr.error('Store not added.');
        }
        console.log(response);
      }, 
      error => {
        this.toastr.error('Store not added');
        console.error(error);
      }
    )
    this.close();
  }
}
